import { styled } from '@mui/system';
import { theme } from 'oems/theme';
import { Divider as DividerMUI } from '@mui/material';

export const SummaryRootWrapper = styled('div')`
    overflow: hidden;
`;

export const SummaryInnerWrapper = styled('div')`
    white-space: nowrap;
    margin-top: 10px;
    position: relative;

    @media (max-width: ${theme.breakpoints.values.md}px) {
        flex-direction: column;
    }
`;

export const Wrapper = styled('div')`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;

    @media (max-width: ${theme.breakpoints.values.md}px) {
        padding: 0 12px;
        flex-direction: column;
        align-items: flex-end;
        justify-content: flex-end;
    }
`;

export const Label = styled('span')`
    margin-top: 5px;
    text-transform: none;
    font-size: 14px;
    font-weight: 700;
    color: ${theme.palette.text.main};
    display: inline-flex;
    overflow: hidden;
    padding-right: 24px;
`;

export const Divider = styled(DividerMUI)`
  margin: 10px 0;
  background-color: rgba(52, 71, 103, 0.4);
`;
